import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  checkServiceAuth,
  getServiceAuthUrl,
  revokeService,
} from "../../../../APICalling/ServiceAPICalling";
// import { authCheckDuration } from "../../../../config/otherConstant";
import PowerOutlinedIcon from "@mui/icons-material/PowerOutlined";
import {
  authCheckDuration,
  getOpenSnakErrorData,
  getOpenSnakSuccessData,
  maxAuthCheck,
  snackDetails,
} from "../../../../config/otherConstant";
import RevokeDialog from "./RevokeDialog";
import { EXTENSION_IDENTIFIER } from "../../../../config/serviceConstant";
import {
  createCronJobOrg,
  deleteCronJobOrg,
  getCronJobsOrg,
} from "../../../../APICalling/Other";
let checkAuthCount;

function OAuth2Authentication({
  apiKey,
  orgId,
  dataCenterUrl,
  dataCenter,
  zApiKey,
  serviceAuth,
  setServiceAuth,
  setAuthServices,
  service,
  serviceConnection,
  allUsers,
  currentUser,
  handlefetchConnections,
  setReload,
  reload,
  setSnack,
}) {
  const [authLoading, setAuthLoading] = useState(true);
  const [revokeLoading, setRevokeLoading] = useState(false);

  let serviceHeaders = {
    orgId: orgId,
    apiKey: apiKey,
    dataCenterUrl: dataCenterUrl,
    dataCenter: dataCenter,
    connName: `${service?.serviceConnection}`,
    zApiKey: zApiKey,
    services: service?.services,
  };

  const getExecuteCronjob = async () => {
    try {
      let delugeRestApi =
        dataCenterUrl +
        "/crm/v2/functions/easyattachmentarchiveforzohocrm__execute/actions/execute?auth_type=apikey&zapikey=" +
        zApiKey;

      let config = {
        orgid: orgId,
        apikey: apiKey,
      };
      let cronJobsOrgResp = await getCronJobsOrg(config);
      let executeJob = cronJobsOrgResp?.data.find(
        (job) => job?.url == delugeRestApi
      );
      if (executeJob?.job_id) {
        return executeJob;
      }
      return {};
    } catch (error) {
      return {};
    }
  };

  const createExecuteCronjob = async () => {
    try {
      let delugeRestApi =
        dataCenterUrl +
        "/crm/v2/functions/easyattachmentarchiveforzohocrm__execute/actions/execute?auth_type=apikey&zapikey=" +
        zApiKey;

      const reqHeaders = {
        orgid: orgId,
        connname: EXTENSION_IDENTIFIER,
        apikey: apiKey,
        datacenterurl: dataCenterUrl,
      };

      const data = {
        url: delugeRestApi,
        name: `${orgId}__${EXTENSION_IDENTIFIER}`,
        params: {},
        headers: reqHeaders,
        body: {},
        type: "GET",
        execute_in: 1,
      };
      const cronjobOrgResp = await createCronJobOrg(data, reqHeaders);
    } catch (error) {}
  };

  const deleteExecuteCronjob = async (jobId) => {
    try {
      let config = {
        orgid: orgId,
        apikey: apiKey,
        settingId: jobId,
      };
      let cronJobsOrgResp = await deleteCronJobOrg(config);
      return cronJobsOrgResp?.data;
    } catch (error) {
      return {};
    }
  };

  const handleAuthenticate = async () => {
    setAuthLoading(true);

    const serviceAuthUrl = await getServiceAuthUrl(serviceHeaders, service);
    if (!serviceAuthUrl) {
      // Set snak error
      setAuthLoading((prev) => false);
      setSnack(getOpenSnakErrorData());
      return "Error";
    }

    checkAuthCount = 1;
    const myAuthCheckInterval = setInterval(async () => {
      const authCheckStatus = await handleAuthCheck();

      if (authCheckStatus) {
        if (service?.name == "Zoho") {
          setTimeout(async () => {
            let executeJob = await getExecuteCronjob();
            if (executeJob?.job_id) {
              // return executeJob;
            } else {
              await createExecuteCronjob();
            }
          }, 5000);
        }
        setSnack(getOpenSnakSuccessData());
        setReload((prev) => !prev);
        setServiceAuth((prev) => true);
        setAuthServices((prev) => [...prev, service?.name]);
        setAuthLoading((prev) => false);
        clearInterval(myAuthCheckInterval);
      }
      if (checkAuthCount++ > maxAuthCheck) {
        setSnack(
          getOpenSnakErrorData(
            "Error!!! Please authenticate and refresh the page.",
            10 * 1000
          )
        );
        setAuthLoading((prev) => false);
        clearInterval(myAuthCheckInterval);
      }
    }, authCheckDuration);

    const newwindow = window.open(
      serviceAuthUrl,
      "windowName",
      "height=640,width=1024"
    );

    if (window.focus) {
      newwindow.focus();
    }
  };

  const handleAuthCheck = async () => {
    try {
      const zohoAuthResp = await checkServiceAuth(serviceHeaders, service);

      return zohoAuthResp;
    } catch (error) {
      return false;
    }
  };

  const handleRevoke = async () => {
    setRevokeLoading((prev) => true);
    const revokeResp = await revokeService(serviceHeaders, service);

    const authCheckStatus = await checkServiceAuth(serviceHeaders, service);

    if (service?.name == "Zoho") {
      let executeJob = await getExecuteCronjob();
      if (executeJob?.job_id) {
        await deleteExecuteCronjob(executeJob?.job_id);
      } else {
      }
    }
    setServiceAuth((prev) => authCheckStatus);
    setAuthServices((prev) =>
      [...prev]?.filter((drive) => drive != service?.name)
    );
    setSnack(getOpenSnakSuccessData());
    setRevokeLoading((prev) => false);
    setReload((prev) => !prev);
  };

  const checkAuth = async (cb) => {
    const zohoStatus = await checkServiceAuth(serviceHeaders, service);

    cb(zohoStatus);
  };

  useEffect(() => {
    if (orgId && apiKey) {
      setAuthLoading((prev) => true);
      checkAuth((bool) => {
        setServiceAuth((prev) => bool);
        if (bool) {
          setAuthServices((prev) => [...prev, service?.name]);
        }
        setAuthLoading((prev) => false);
      });
    }
  }, [reload]);

  if (authLoading) {
    return (
      <Button
        disabled
        variant="outlined"
        sx={{ border: "none", textTransform: "none" }}
      >
        Authenticating...
      </Button>
    );
  }

  if (revokeLoading) {
    return (
      <Button
        disabled
        variant="outlined"
        sx={{ border: "none", textTransform: "none" }}
      >
        Revoking...
      </Button>
    );
  }

  if (!serviceAuth) {
    return (
      <Button
        onClick={handleAuthenticate}
        variant="outlined"
        sx={{ textTransform: "none", width: "100%" }}
        color="success"
        startIcon={<PowerOutlinedIcon />}
      >
        {/* Connect {service?.name} */}
        Connect
      </Button>
    );
  }

  if (serviceAuth) {
    return (
      <RevokeDialog
        service={service?.name}
        handleRevokeService={handleRevoke}
      />
    );
  }

  return <></>;
}

export default OAuth2Authentication;
